export const isSignedIn = () => {
  return !!gon.currentUser;
}